export default {
  namespaced: true,
  state: {
    errorLoadConfigStatus: false
  },
  mutations: {
    changeErrorLoadConfigStatus(state, payload) {
      state.errorLoadConfigStatus = payload
    }
  },
  actions: {
    changeErrorLoadConfigStatus({ commit }, status) {
      commit('changeErrorLoadConfigStatus', status)
    }
  }
}
